export default "__VITE_ASSET__1XH2pb7e__"